import gql from 'graphql-tag';
import { CREDIT_SUBMISSION_DECISION_FRAGMENT } from './fragments';

export const UPDATE_CREDIT_SUBMISSION_DECISION = gql`
  ${CREDIT_SUBMISSION_DECISION_FRAGMENT}
  mutation UpdateCreditSubmissionDecision(
    $creditSubmissionDecisionId: ID!
    $input: UpdateCreditSubmissionDecisionInput!
  ) {
    result: creditSubmissionDecision {
      update(creditSubmissionDecisionId: $creditSubmissionDecisionId, input: $input) {
        error
        success
        entity {
          ...CreditSubmissionDecisionFields
        }
      }
    }
  }
`;
